module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ChangePickUpInfoView.js"));
	}, "ChangePickUpInfoView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ChangePickUpInfoView!./src/pages/Shop/CheckOrder/ChangePickUpInfo/ChangePickUpInfoView.js
// module id = 887
// module chunks = 431